"use client";

import React from "react";
import { ArrowRight, PhoneCall, CircleCheck as CheckCircle2 } from 'lucide-react';
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallToAction() {
  const shouldReduceMotion = useReducedMotion();
  const benefits = ["Apoio técnico especializado", "Estudo dimensional à medida", "Representante Spraying Systems Co."];
  return <section id="calltoaction" data-nav="light" className="relative overflow-hidden bg-background py-20 lg:py-28">
      {/* Subtle decorative background pattern */}
      <div className="pointer-events-none absolute inset-0 -z-10 flex items-center justify-center opacity-40">
        <div className="h-[480px] w-[480px] rounded-full bg-secondary/10 blur-3xl" />
        <div className="h-[320px] w-[320px] -translate-x-32 translate-y-16 rounded-full bg-primary/10 blur-2xl" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative mx-auto max-w-5xl rounded-3xl border border-border bg-card p-8 shadow-xl sm:p-12 lg:p-16">
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 rounded-full border border-secondary/20 bg-secondary/10 px-3.5 py-1 text-xs font-medium text-secondary">
                <span className="size-1.5 rounded-full bg-secondary" />
                Eurocontrol Engenharia
              </div>

              <h2 className="font-default mt-4 text-2xl font-bold tracking-tight text-card-foreground sm:text-3xl lg:text-4xl">
                Pronto para otimizar os seus processos de pulverização industrial?
              </h2>

              <p className="font-default mt-4 text-base text-muted-foreground sm:text-lg">
                Fale com a nossa equipa técnica e obtenha uma solução à medida para aumentar a precisão, reduzir o consumo e valorizar a sua linha produtiva.
              </p>

              <div className="mt-6 flex flex-wrap gap-y-2 gap-x-6">
                {benefits.map((benefit, i) => <div key={benefit} data-index={i} className="inline-flex items-center gap-2 text-sm font-medium text-card-foreground">
                    <CheckCircle2 className="size-4 text-secondary shrink-0" />
                    <span>{benefit}</span>
                  </div>)}
              </div>
            </div>

            <div className="flex flex-col gap-4 lg:col-span-5 lg:items-end">
              <Button asChild size="lg" className="w-full justify-center text-base sm:w-auto font-medium">
                <Link to="/ContactsPage" className="inline-flex items-center gap-2">
                  <span>Solicite um orçamento</span>
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <p className="text-xs text-muted-foreground text-center lg:text-right">
                Resposta técnica personalizada em menos de 24 horas úteis.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}